import { buildTextdomain } from 'react-gettext';
import Localization from '@dealersites/core/translations/Localization';

const i18n = (global.i18n = global.i18n || {});
const THEME_TEXT_DOMAIN = 'oem-theme';

const translations = {
  en: buildTextdomain(require('./en.json')),
  fr: buildTextdomain(require('./fr.json')),
};

const themeLocalization = new Localization(translations, THEME_TEXT_DOMAIN);
i18n.theme = themeLocalization;

export { themeLocalization, translations, THEME_TEXT_DOMAIN };
